package co.maytes.standupbot.dashboard.features.setup

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.shared.dto.setup.SetupStatusDto

class SetupStatusStore(private val api: ApiClient) {
    var state: SetupStatusState by mutableStateOf(SetupStatusState())
        private set

    suspend fun refresh(workspaceId: String) {
        state = state.loadingStarted()
        state =
            when (val res = api.get<SetupStatusDto>("/api/v1/workspaces/$workspaceId/setup-status")) {
                is Result.Ok -> state.loaded(res.value)
                is Result.Err -> state.failed(res.error.displayMessage)
            }
    }

    fun dismissBanner() {
        state = state.bannerDismissed()
    }
}
